import script from "./TemplateHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateHeader.vue?vue&type=script&lang=ts&setup=true"

import "./TemplateHeader.vue?vue&type=style&index=0&id=53f8471a&lang=css"

const __exports__ = script;

export default __exports__